import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  LeadSourcesList: { data: [], pagination: { currentPage: 1, perPage: constants.tableUI.defaultPerpage, total: 0 }},
  errors: { title: "" },
  errorMessage: "",
};

const LeadSources = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case actionTypes.GET_LEAD_SOURCES_SUCCESS:
      return {
          ...state,
          loading: false,
          LeadSourcesList: action.payload,
          // errors: { leadSourceId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_LEAD_SOURCES_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.CREATE_LEAD_SOURCE_SUCCESS:
      return {
          ...state,
          loading: false,
          // LeadSourcesList: action.payload,
          // errors: { leadSourceId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.CREATE_LEAD_SOURCE_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_LEAD_SOURCE_SUCCESS:
      return {
          ...state,
          loading: false,
          // LeadSourcesList: action.payload,
          // errors: { leadSourceId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.UPDATE_LEAD_SOURCE_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.DELETE_LEAD_SOURCE_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.DELETE_LEAD_SOURCE_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_LEAD_SOURCE_STATUS_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.UPDATE_LEAD_SOURCE_STATUS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    default:
        return state;
  }
};

export default LeadSources;
